import Radio from '@/common/components/Radio'
import { cn } from '@/common/utils/cn'
import { formatPercentage } from '@/common/utils/formatters'
import {
  integrationProviderLabels,
  integrationStatusColorClass,
  integrationStatusLabels,
} from '@/features/equipmentModels/constants/integrationStatusOptions.constant'
import { EquipmentModelIntegrationCodeData } from '@/features/equipmentModels/types/equipmentModelIntegrationCode'

interface IntegrationCodeCardProps {
  integrationCode: EquipmentModelIntegrationCodeData
  isSelected: boolean
  onSelect: () => void
}

const IntegrationCodeCard = ({ integrationCode, isSelected, onSelect }: IntegrationCodeCardProps) => {
  const providerLabel = integrationProviderLabels[integrationCode.provider] ?? integrationCode.provider
  const statusLabel = integrationStatusLabels[integrationCode.integration_status]
  const statusColor = integrationStatusColorClass[integrationCode.integration_status]
  const progress = formatPercentage(Number(integrationCode.linking_progress_percentage))
  const isInProgress = integrationCode.integration_status === 'link_in_progress'

  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        'w-full flex items-center gap-2 p-4 rounded-lg text-left transition-colors min-h-20',
        isSelected ? 'bg-blue-100' : 'bg-white-100 hover:bg-white-200',
      )}
      data-testid={`integration_code_${integrationCode.id}`}
    >
      <Radio checked={isSelected} onChange={onSelect} />

      <div className="flex flex-col gap-1 min-w-0 flex-1">
        <p className="text-base font-bold leading-5 truncate">{providerLabel}</p>

        <div className="flex gap-2">
          <div className="flex flex-col gap-1 min-w-0 flex-1">
            <p className="text-[10px] italic font-light leading-3 text-white-800 truncate">Código da integração</p>

            <p className="text-xs font-bold truncate">{integrationCode.value}</p>
          </div>

          <div className="flex flex-col gap-1 min-w-0 flex-1">
            <p className={cn('text-[10px] italic font-light leading-3 truncate', statusColor)}>Status</p>

            <p className={cn('text-xs font-bold truncate', statusColor)}>
              {isInProgress ? progress : statusLabel}
            </p>
          </div>
        </div>
      </div>
    </button>
  )
}

export default IntegrationCodeCard
